import reducer from './reducers';

export { default as glossaryActions } from './actionCreators';
export { default as glossarySagas } from './sagas';

export default reducer;
